
/**
 * Created by rlopez on 11/28/16.
 */
// ActionDetailsView.js

import {View} from 'backbone'
import template from '../../../../../templates/dashboard/connections/details/action-google-spreadsheets.ejs';
import * as gridModels from '../action-type/ActionGridModels.js';
import util from '../../../../service/util/Util.js';
import constants from '../../../../constants/Constants.js';
import sequenceService from 'SequenceService';

import _ from 'lodash';
//
class ActionGoogleSpreadsheets extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            "click button[name=addSend], button[name=addReturn]"          : "itemNew",
            "click button[name=removeSend], button[name=removeReturn]"    : "itemRemove",
            "click button[name=upSend], button[name=upReturn]"            : "itemUp",
            "click button[name=downSend], button[name=downReturn]"        : "itemDown",
            "click button[name=autoSend], button[name=autoReturn]"        : "autoComplete"
        };
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeTableName(){
        return this.actionService.changeTableName.apply(this.actionService, arguments);
    }

    changeDistinct(){
        return this.actionService.changeDistinct.apply(this.actionService, arguments);
    }

    itemNew(){
        return this.actionService.itemNew.apply(this.actionService, arguments);
    }

    itemRemove(){
        return this.actionService.itemRemove.apply(this.actionService, arguments);
    }

    itemDown(){
        return this.actionService.itemDown.apply(this.actionService, arguments);
    }

    itemUp(){
        return this.actionService.itemUp.apply(this.actionService, arguments);
    }

    autoComplete(ev){
       return this.actionService.autoComplete(ev)
            .then(result => {
               let currentModel = this.model.get('currentActionDetails');
               const isUpdate = this.model.get('currentActionDetails').Type === '83';
               const isSend = ev.target.name  === 'autoSend';
               let op = isSend ? '0' : '-1';
               // Always reset fields
               let parameters = [];

               result.forEach(col => {
                    parameters.push({
                        _fixedValue: '',
                        _id: sequenceService.nextDomId(),
                        _isFixed: "false",
                        _name: col['@name'],
                        _operation: op,
                        _value: col['@name']
                    })
               });

               // Update model
               if(isSend){
                    if(isUpdate){
                      const returns = currentModel.ActionXML.Action.Send.Parameter.filter(i => i._operation === '-1');
                      currentModel.ActionXML.Action.Send.Parameter = parameters.concat(returns);
                    }else{
                      currentModel.ActionXML.Action.Send.Parameter = parameters;
                    }
               }
               else {
                    if(isUpdate){
                        const sends = currentModel.ActionXML.Action.Send.Parameter.filter(i => i._operation !== '-1');
                        currentModel.ActionXML.Action.Send.Parameter = sends.concat(parameters);
                    }else{
                        currentModel.ActionXML.Action.Receive.Parameter = parameters;
                    }
               }

               // Save and render
               this.model.set('currentActionDetails', currentModel, { silent: true });
               this.model.set('hasChanges', true);
               this.render();
            }).catch(err => {
            });
    }



    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderGridsByType(){
        console.log("Re rendering Grid");
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        $('.select,.update,.insert,.delete,.store').addClass('hide');
        switch (currentModel.Type){


            case constants.CONNECTION_GOOGLE_UPDATE:
            case constants.CONNECTION_GOOGLE_READ:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_GOOGLE_PARAMETER_HEADERS_SEND,
                    constants.CONNECTION_UPDATE_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_GOOGLE_PARAMETER_HEADERS_RETURN,
                    constants.CONNECTION_UPDATE_RETURN_CONTAINER,
                );
                $('.update').removeClass('hide');break;
            case constants.CONNECTION_GOOGLE_INSERT:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_GOOGLE_PARAMETER_HEADERS_SEND,
                    constants.CONNECTION_INSERT_SEND_CONTAINER
                );
                $('.insert').removeClass('hide');
                break;
            case constants.CONNECTION_GOOGLE_DELETE:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_GOOGLE_PARAMETER_HEADERS_SEND,
                    constants.CONNECTION_DELETE_SEND_CONTAINER
                );
                $('.delete').removeClass('hide');
                break;
            case constants.CONNECTION_GOOGLE_SELECT:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_GOOGLE_PARAMETER_HEADERS_SEND,
                    constants.CONNECTION_SELECT_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_GOOGLE_PARAMETER_HEADERS_RETURN,
                    constants.CONNECTION_SELECT_RETURN_CONTAINER,
                );
                $('.select').removeClass('hide');
                break;
        }
        this.resizeGrid();
    }

    renderParametersGrid(colSendModel,colSendNames,colSendContainer,colReturnModel,colReturnNames,colReturnContainer){
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        console.log("Current Action Details",currentModel);
        let sendItemsToRender = [];
        const isUpdate = currentModel.Type === constants.CONNECTION_GOOGLE_UPDATE;
        const isInsert = currentModel.Type === constants.CONNECTION_GOOGLE_INSERT;

        // PF-3074 Adding Special Treatment for Insert on Google Spreadsheets.
        if(isInsert){
            sendItemsToRender = (currentModel.ActionXML.Action.Send.Parameter instanceof Array) ? currentModel.ActionXML.Action.Send.Parameter : [currentModel.ActionXML.Action.Send.Parameter];
        }else {
            if (currentModel.ActionXML.Action.Send.Parameter instanceof Array) {
                sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation !== '-1');
            } else {
                if (currentModel.ActionXML.Action.Send.Parameter && currentModel.ActionXML.Action.Send.Parameter._operation !== '-1') {
                    sendItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
                }
            }
        }

        let returnItemsToRender = [];
        if(isUpdate){
           if(currentModel.ActionXML.Action.Send.Parameter instanceof Array){
             returnItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
           }else{
             returnItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
           }
        }else{
           returnItemsToRender = currentModel.ActionXML.Action.Receive.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Receive.Parameter
            : [currentModel.ActionXML.Action.Receive.Parameter];
        }

        let gridSendObject = util.getGridObject(this,{
            colModel:colSendModel,
            colNames:colSendNames,
            autowidth:true,
            height: 300,
            scrollOffset:0,
            ondblClickRow:this.ondblClickRowSend});
        let gridReturnObject = util.getGridObject(this,{
            colModel:colReturnModel,
            colNames:colReturnNames,
            autowidth:true,
            height: 300,
            scrollOffset:0,
            ondblClickRow:this.ondblClickRowReceive});

        $(colSendContainer).jqGrid(gridSendObject);
        $(colReturnContainer).jqGrid(gridReturnObject);
        _.forEach(sendItemsToRender, (field, index) => {
            if(field['_operation'] === '-1' && currentModel.Type === '83'){
                self.fillNewRow(colReturnContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                                field['_name'],field['_operation'] ,field['_value']);
            }else{
                self.fillNewRow(colSendContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                                field['_name'],field['_operation'] ,field['_value']);
            }
        });
        _.forEach(returnItemsToRender, (field, index) => {
            self.fillNewRow(colReturnContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                field['_name'],field['_operation'] ,field['_value']);
        });
    }

    ondblClickRowSend (rowid, iRow,iCol){
        let containerToWork='#' + this.id;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    ondblClickRowReceive (rowid, iRow,iCol){
        let containerToWork='#' + this.id;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        let currentGrid=this.model.get('currentGridSelector'),
            currentModel=this.model.get('currentActionDetails'),
            isSend =  currentGrid.indexOf('Send') > 0,
            isUpdate = currentModel.Type === '83';

        console.log('Current Grid',currentGrid);
        console.log("Editing",rowId);
        console.log("Editing",cellName);
        console.log("Editing",value);
        if(isUpdate){
            let arraySend = currentModel.ActionXML.Action.Send.Parameter;
            let arrayReceive = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
            if(isSend){
                if(cellName === '_value'
                    && arraySend[rowId]['_isNew']
                    && arraySend[rowId]['_isNew'] !== 'false'){
                    arraySend[rowId]['_name'] = value;
                    arraySend[rowId]['_isNew']=false;
                }
                else if(cellName === '_name'){
                    arraySend[rowId]['_isNew']=false;
                }
                arraySend[rowId][cellName] = value;
            }else{
                if(cellName === '_value' &&
                    arrayReceive[rowId]['_isNew'] &&
                    arrayReceive[rowId]['_isNew'] !== 'false'){
                    arrayReceive[rowId]['_name'] = value;
                    arrayReceive[rowId]['_isNew']=true;
                }
                arrayReceive[rowId][cellName] = value;
            }
            //currentModel.ActionXML.Action.Send.Parameter = arraySend.concat(arrayReceive);
        }else{
            if(isSend){
                if(cellName === '_value' &&
                    currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] &&
                    currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] !== 'false'){

                    currentModel.ActionXML.Action.Send.Parameter[rowId]['_name'] = value;
                    currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']=false;
                }
                else if(cellName === '_name'){
                    currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']=false;
                }
                currentModel.ActionXML.Action.Send.Parameter[rowId][cellName] = value;
            }
            else{
                if(cellName === '_value' &&
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] &&
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] !== 'false'){

                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_name'] = value;
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew']=false;
                }
                currentModel.ActionXML.Action.Receive.Parameter[rowId][cellName] = value;
            }
        }

        this.model.set('currentActionDetails',currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.model.trigger('change');
        console.log("Model After Save Cell",currentModel);
    }

    onSelectRow(){}

    onCellSelect(){}

    onDoubleClickRow(){}

    fillNewRow(grid,index, _fixedValue,_id,_isFixed,_name, _operation, _value) {
        $(grid).addRowData(index, {
            '_fixedValue':_fixedValue,
            '_id': _id,
            '_isFixed':_isFixed,
            '_name':_name,
            '_operation':_operation,
            '_value':_value
        });
    }

    setRow(rowId, e){
        console.log('before select row',e);

        let nameUp = 'upReturn',
            nameDown = 'downReturn',
            isSend = e.currentTarget.id.indexOf('Send') > 0,
            index = 1;
        
        if(isSend){
           nameUp = 'upSend';
           nameDown = 'downSend';
        }

        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
    
        $('[data-table-type]').attr('disabled', false);
        
        if($(`#${e.currentTarget.id}`).jqGrid('getGridParam', 'records') === 1){
           $(`button[name='${nameUp}'][data-table-type='${e.currentTarget.id}']`).attr('disabled', true);
           $(`button[name='${nameDown}'][data-table-type='${e.currentTarget.id}']`).attr('disabled', true);
        }else if($(`#${e.currentTarget.id}`).jqGrid('getGridParam', 'records') === (Number(rowId) + index) ){
           $(`button[name='${nameDown}'][data-table-type='${e.currentTarget.id}']`).attr('disabled', true);
        }
        else if(Number(rowId) + index === 1){
           $(`button[name='${nameUp}'][data-table-type='${e.currentTarget.id}']`).attr('disabled', true);
        }
        
        this.model.set('currentGridSelector',`#${e.currentTarget.id}`,{silent:true});
    }//

    afterEditCell(rowId, cellName, value, iRow, iCol){
        let self=this;
        $("#"+iRow+"_"+cellName).bind('blur',function(){
            $(self.model.get('currentGridSelector')).saveCell(iRow,iCol);
        });
    }

    render(){
        console.log("Rendering Grids");
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.renderGridsByType();

        this.delegateEvents();
        return this;
    }

}

export default ActionGoogleSpreadsheets;